import React from 'react';

//components
import BasicButton from '../BasicButton';
import Icon from '../../icons/Icon';

//interfaces
import { IconLibrary } from '../../../../interfaces/icon/IconLibrary';
import { IUpDownButtonPanel } from '../../../../interfaces/buttons/ButtonPanels';



const UpDownButtonPanel = ({
    panelClassName,
    upDisabled,
    downDisabled,
    upText,
    downText,
    ariaLabelUp,
    ariaLabelDown,
    onUpClick,
    onDownClick}: IUpDownButtonPanel) => {

    return (
        <div className={`up-down-button-panel-wrapper ${panelClassName ?? ""}`} >
            <BasicButton 
                className="up-down-button-panel-button move-up-button" 
                content={
                    <>
                    <Icon className='arrow-icon' iconName={IconLibrary.ARROW_LEFT} sizeInPx='10' color='var(--thriveNavy)'/>
                    {upText || ""}
                    </>
                } 
                ariaLabel={ariaLabelUp}
                isDisabled={upDisabled}
                onButtonClick={onUpClick}    
            />

            <BasicButton 
                className="up-down-button-panel-button move-down-button" 
                content={
                    <>
                    <Icon className='arrow-icon' iconName={IconLibrary.ARROW_LEFT} sizeInPx='10' color='var(--thriveNavy)'/>
                    {downText || ""}
                    </>
                } 
                ariaLabel={ariaLabelDown}
                isDisabled={downDisabled}
                onButtonClick={onDownClick}    
            />
        </div>

    );
};

export default UpDownButtonPanel